import { render, staticRenderFns } from "./AddLocationMapping.vue?vue&type=template&id=b739b478&"
import script from "./AddLocationMapping.vue?vue&type=script&lang=js&"
export * from "./AddLocationMapping.vue?vue&type=script&lang=js&"
import style0 from "./AddLocationMapping.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports